import { Quote } from "lucide-react";

export const AboutFounder = () => {
  return (
    <section data-testid="about-founder" className="bg-[#042D1F]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="max-w-3xl">
          <Quote className="h-8 w-8 text-emerald-400/70 mb-5" strokeWidth={1.5} />
          <p data-testid="about-founder-message" className="text-lg sm:text-xl text-white/90 leading-relaxed font-medium">
            "Our goal is to connect quality Indian agricultural and natural products with buyers across the world
            while building trust, reliability and long-term business relationships."
          </p>
          <div className="mt-6">
            <p data-testid="about-founder-name" className="text-base font-semibold text-white">
              Jyoti K. Gaware
            </p>
            <p data-testid="about-founder-title" className="text-sm text-white/60">
              Owner &amp; Founder — RKG NATURALS
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
